import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useAppMeta } from "hooks";
import { useCreateAccountLedgerMutation } from "store/services/accountLedgerApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AccountLedgerForm from "./accountLedgerComponents/AccountLedgerForm";

const breadcrumbs = [
  { title: "Account Ledger", path: "/app/crm/account-ledger/list" },
  { title: "New Account Ledger" },
];

const AccountLedgerCreateScreen = () => {
  const navigate = useNavigate();

  // RTK Query
  const [createAccountLedger, { isLoading: creatingAccountLedger }] =
    useCreateAccountLedgerMutation();

  useAppMeta("New Account Ledger");

  // methods

  const handleCreateAccountLedger = async (data) => {
    try {
      const { _id } = await createAccountLedger(data).unwrap();
      toast.success("Account Ledger successfully created!");
      navigate(`/app/crm/account-ledger/${_id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create accountLedger!");
    }
  };

  useAppMeta("New Account Ledger");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingAccountLedger}>
      <BreadcrumbLayout.Paper>
        <AccountLedgerForm
          onSubmit={handleCreateAccountLedger}
          isBusy={creatingAccountLedger}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountLedgerCreateScreen;
